import script from "./addNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./addNotice.vue?vue&type=script&setup=true&lang=js"

import "./addNotice.vue?vue&type=style&index=0&id=308159bd&lang=scss&scoped=true"

import exportComponent from "/root/workspace/public_sso_CS39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-308159bd"]])

export default __exports__